import React from "react";
import UaeMofaHead from "../../UaeAttestation/UaeMofa/UaeMofaHead";
import "./../../UaeAttestation/UaeMofa/UaeMofa.css";
import UkMofaMain from "./UkMofaMain";
const UkMofa = () => {
  return (
    <div className="uaeMofaContainer">
      <UaeMofaHead />
      <UkMofaMain />{" "}
    </div>
  );
};

export default UkMofa;
